import { Identifier } from "../../core";
export class ExtraFeeId extends Identifier {
    constructor(id) {
        super("ExtraFeeId", id);
    }
}
